import { fakerRU as faker } from '@faker-js/faker';

import { sumBy } from 'lodash';
import { devices } from './devices';
import { splitPercent } from './utils';

const devicesData = devices.map((device) => {
  const income = device.maxDayTotal * 30;
  const taxes = (6 * income) / 100;
  const expenses = splitPercent(faker.number.int({ min: 15, max: 30 }), income);
  return {
    deviceId: device.Id,
    address: device.Info.Address,
    currency: 'RUB',
    profit: income - taxes - expenses,
    income,
    expenses,
    taxes,
    firstSaleTs: +new Date(),
    periodStatus: 2,
    capitalExpenses: expenses * faker.number.int({ min: 3, max: 5 }),
    monthCount: 1.2
  };
});

export const allQuick = {
  devices: devicesData,
  total: {
    profit: sumBy(devicesData, (d) => d.profit),
    income: sumBy(devicesData, (d) => d.income),
    expenses: sumBy(devicesData, (d) => d.expenses),
    taxes: sumBy(devicesData, (d) => d.taxes),
    capitalExpenses: sumBy(devicesData, (d) => d.capitalExpenses),
    currency: 'RUB'
  },
  sales: {
    devices: devices.reduce(
      (acc, device) => {
        acc[device.Id] = {
          Banknotes: device.DeviceState.DailySales.Sum.Banknotes,
          Coins: device.DeviceState.DailySales.Sum.Coins,
          Litres: device.DeviceState.DailySales.Sum.Litres,
          Bankcard: device.DeviceState.DailySales.Sum.Bankcard,
          MobileApp: device.DeviceState.DailySales.Sum.MobileApp,
          Exchange: device.DeviceState.DailySales.Sum.Exchange,
          Amount: device.DeviceState.DailySales.Sum.Amount
        };
        return acc;
      },
      {} as Record<string, unknown>
    ),
    period: {
      fromIso: new Date().toISOString(),
      toIso: new Date().toISOString(),
      fromTs: +new Date(),
      toTs: +new Date()
    }
  },
  perfInMillis: {
    step1AllUserDevices: 75.529,
    step2GetFinStatementsForUserDevices: 22.166,
    step3GetFirstSalesForEachDevice: 133.995,
    step4ConvertDataToPeriodsFromTo: 3.852,
    step5GetElectricityForAllDevices: 25.22,
    step6GetMoneySalesForPeriod: 2293.587,
    step7ComputeWithBusinessLogicRules: 0.609
  }
};

export const settings = {
  profitabilityRate: 70,
  profitabilityType: 0,
  showHasProfitabilityProblem: true
};
